import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pendingStatusTooltip'
})
export class PendingStatusTooltipPipe implements PipeTransform {
  transform(icon: string, locationVerification: boolean) {
    switch (icon) {
      case 'send-black':
        return 'Verzonden';
      case 'check-black':
        return locationVerification ? 'Locatiebepaling in orde' : 'Goedgekeurd';
      case 'double-check-black':
        return 'Afgewerkt';
      case 'exclamation':
        return 'Locatiebepaling nog niet in orde';
    }
  }
}
